
<template>
  <router-view v-if="isRouterAlive" />
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  provide() {
    return { reload: this.reload }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    }
  }
})
</script>
